import React from 'react'
import Navbar from '../inc/Navbar'
import { Link } from "react-router-dom";
import computercare from "../images/Computer care.jpg";

import tplink from "../images/TP LINK.jpg";
import lightcable from "../images/LENGHT CABLE.jpg";
import ssddeul from "../images/SSD Deul protocol.jpg";
import fiberpatchcord from "../images/FIBAR PATCH CORD.jpg";
import HDMI from "../images/HDMI.jpg";
import lapcare from "../images/LAPCARE.jpg";
import dell from "../images/Dell.jpg";
import hplaptop from "../images/Hp Laptop.jpg";
import lenovo from "../images/LENOVO.jpg"




function ComputerCare() {
  return (
    <div>
      <Navbar />
      <br />
      <br />
      <br />
      <div className="cctvfotageberhampore">
        <div className="album py-1">

          <div className="container mt-4">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item"><Link to="/" href="#">Home</Link></li>
                <li className="breadcrumb-item active" aria-current="page">Computer Care</li>
              </ol>
            </nav>
          </div>
        </div>
      </div>
      
<div className='computershopberhampore'>
        <br />
        <div className="album py-1">

          <div className="container">
            <div className="row">
                <div className="col-md-4 mt-3" >
                <div className='card shadow'>
                  <img src={dell} className="card-img-top" alt="dell"/>
                  <div className='card-body'>
                    <h5 style={{ color: "darkblue" }} className='mb-1'><b>Dell</b></h5>
                  </div>
                </div>
              </div>
                <div className="col-md-4 mt-3" >
                <div className='card shadow'>
                  <img src={hplaptop} className="card-img-top" alt="HP Laptop"/>
                  <div className='card-body'>
                    <h5 style={{ color: "darkblue" }} className='mb-1'><b>HP Laptop</b></h5>
                  </div>
                </div>
              </div>
                <div className="col-md-4 mt-3" >
                <div className='card shadow'>
                  <img src={lenovo} className="card-img-top" alt="lenovo"/>
                  <div className='card-body'>
                    <h5 style={{ color: "darkblue" }} className='mb-1'><b>Lenovo</b></h5>
                  </div>
                </div>
              </div>

              <div className="col-md-4 mt-3" >
                <div className='card shadow'>
                  <img src={tplink} className="card-img-top" alt="tplink"/>
                  <div className='card-body'>
                    <h5 style={{ color: "darkblue" }} className='mb-1'><b>TP Link</b></h5>
                  </div>
                </div>
              </div>
              <div className="col-md-4 mt-3" >
                <div className='card shadow'>
                  <img src={lightcable} className="card-img-top" alt="lightcable"/>
                  <div className='card-body'>
                    <h5 style={{ color: "darkblue" }} className='mb-1'><b>LIGHT Cable</b></h5>
                  </div>
                </div>
              </div>
              <div className="col-md-4 mt-3" >
                <div className='card shadow'>
                  <img src={ssddeul} className="card-img-top" alt="ssddeul" />
                  <div className='card-body'>
                    <h5 style={{ color: "darkblue" }} className='mb-1'><b>SSD Deul Potocol</b></h5>
                  </div>
                </div>
              </div>

              <div className="col-md-4 mt-3" >
                <div className='card shadow'>
                  <img src={fiberpatchcord} className="card-img-top" alt="fiberpatchcord"/>
                  <div className='card-body'>
                    <h5 style={{ color: "darkblue" }} className='mb-1'><b>Fiber Patch Cord</b></h5>
                  </div>
                </div>
              </div>

    <div className="col-md-4 mt-3" >
                <div className='card shadow'>
                  <img src={HDMI} className="card-img-top" alt="HDMI"/>
                  <div className='card-body'>
                    <h5 style={{ color: "darkblue" }} className='mb-1'><b>HDMI</b></h5>
                  </div>
                </div>
              </div>

                  <div className="col-md-4 mt-3" >
                <div className='card shadow'>
                  <img src={lapcare} className="card-img-top" alt="lapcare"/>
                  <div className='card-body'>
                    <h5 style={{ color: "darkblue" }} className='mb-1'><b>Lapcare Motherboard</b></h5>
                  </div>
                </div>
              </div>
              
            </div>
          </div>
        </div>
        <br />
        <br />
      </div>
      <br />
      <div className="album py-1">

        <div className="container ">
          <div className="row">

            <div className="col-md-8">
              <h1 style={{color:"#030D54"}}> <b>Computer Care</b></h1>
              <hr />
              <p className='justify'>Our Computer Care service ensures fast, reliable support for all your devices across Berhampore. We handle <b>PC & laptop repair</b>, software installation, virus removal, system upgrades, and regular maintenance to keep your devices running smoothly. Perfect for homes, offices, and businesses in Berhampore needing dependable and prompt technical support.</p>
              <br />
              
               <a className='mb-3' href='tel: 9064797437'>Help Line No. 9064797437</a>
               <br/>
               <br/>
            </div>
            <div className="col-md-4">
                    <img src={computercare} className="d-block w-100" alt="Intercomcomputercare"/>

            </div>
          </div>

        </div>
      </div>


    </div>
  )
}

export default ComputerCare